// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   REPORTS & ARCHIVE PAGE
   ============================================================ */

.reports-subtitle {
  color: var(--text-primary);
  opacity: 0.65;
  font-size: 14px;
  line-height: 1.6;
  max-width: 760px;
  margin: -8px 0 20px;
}

/* ---------- Filter bar ---------- */

.reports-filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 22px;
}

.reports-search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 0 14px;
  min-width: 260px;
  flex: 1 1 260px;
  max-width: 360px;
  color: var(--text-primary);
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.reports-search:focus-within {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 12%, transparent);
}

.reports-search svg {
  flex-shrink: 0;
  opacity: 0.45;
}

.reports-search input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  width: 100%;
  color: var(--text-primary);
}

/* ---------- Custom-styled selects ---------- */

.reports-select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
}

.reports-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 100%;
  border: 1px solid var(--border);
  background: var(--card-bg);
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 500;
  padding: 0 30px 0 14px;
  border-radius: 10px;
  cursor: pointer;
  min-width: 130px;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.reports-select:hover {
  border-color: var(--primary);
}

.reports-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 12%, transparent);
}

.reports-select-caret {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-primary);
  opacity: 0.45;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

/* When a filter is actively selected (not the "all" default), give it
   a filled, colored look so active filters are obvious at a glance. */
.reports-select-wrapper.has-value .reports-select {
  border-color: var(--primary);
  background: color-mix(in srgb, var(--primary) 6%, transparent);
  color: var(--primary);
  font-weight: 600;
}

.reports-select-wrapper.has-value .reports-select-caret {
  color: var(--primary);
  opacity: 0.8;
}

.reports-clear-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  border: none;
  background: transparent;
  color: var(--text-primary);
  opacity: 0.55;
  font-size: 13px;
  cursor: pointer;
  margin-left: auto;
  padding: 0 4px;
  transition: opacity 0.2s ease;
}

.reports-clear-btn:hover {
  opacity: 0.9;
}

/* ---------- Current week panel ---------- */

.current-week-panel {
  background: rgba(46, 125, 50, 0.06);
  border: 1px solid rgba(46, 125, 50, 0.18);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 28px;
}

.current-week-header {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 18px;
}

.current-week-eyebrow {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #2e7d32;
  margin-bottom: 6px;
}

.current-week-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.current-week-title-row h3 {
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  color: var(--text-primary);
}

.new-badge {
  background: #2e7d32;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 3px 9px;
  border-radius: 999px;
}

.download-all-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
  padding: 9px 16px;
  border-radius: 10px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease;
}

.download-all-btn:hover {
  background: var(--hover);
}

/* ---------- Report cards (shared by current week + archive) ---------- */

.reports-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 16px;
}

.report-card {
  display: flex;
  flex-direction: column;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.report-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.report-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  flex-shrink: 0;
}

.report-card-title {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 8px;
  color: var(--text-primary);
  line-height: 1.3;
}

.report-card-summary {
  font-size: 13px;
  color: var(--text-primary);
  opacity: 0.62;
  line-height: 1.55;
  margin: 0 0 14px;
  flex: 1 1;
}

.report-card-filesize {
  font-size: 12px;
  color: var(--text-primary);
  opacity: 0.45;
  margin-bottom: 14px;
}

.report-card-download {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1.5px solid var(--accent, var(--primary));
  background: transparent;
  color: var(--accent, var(--primary));
  font-size: 13px;
  font-weight: 600;
  padding: 9px 0;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.report-card-download:hover {
  background: var(--accent, var(--primary));
  color: #fff;
}

/* ---------- Archive ---------- */

.archive-section {
  padding-bottom: 24px;
}

.archive-eyebrow {
  display: block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--text-primary);
  opacity: 0.5;
  margin-bottom: 12px;
}

.week-accordion-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.week-accordion-item {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
}

.week-accordion-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.week-accordion-header:hover {
  background: var(--hover);
}

.week-accordion-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.week-accordion-meta {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

.week-accordion-count {
  font-size: 13px;
  color: var(--text-primary);
  opacity: 0.5;
}

.week-accordion-chevron {
  transition: transform 0.2s ease;
  color: var(--text-primary);
  opacity: 0.5;
}

.week-accordion-chevron.open {
  transform: rotate(180deg);
}

.week-accordion-body {
  padding: 4px 18px 20px;
  border-top: 1px solid var(--border);
  padding-top: 18px;
}

/* ---------- Loading / error states ---------- */

.reports-status {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 50px 0;
  color: var(--text-primary);
  opacity: 0.6;
  font-size: 14px;
}

.reports-status-spin {
  animation: reports-spin 0.8s linear infinite;
}

@keyframes reports-spin {
  to {
    transform: rotate(360deg);
  }
}

.reports-retry-btn {
  width: fit-content;
}

/* ---------- Locked archive (demo accounts) ---------- */
/* A faded, inert preview of the first few archive weeks sits underneath;
   a bottom-weighted gradient fades it into the page background; the lock
   card is centered on top of both. */

.archive-locked-preview {
  position: relative;
  min-height: 220px;
  overflow: hidden;
  border-radius: 14px;
}

.archive-locked-list {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.archive-locked-fade {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    color-mix(in srgb, var(--background) 15%, transparent) 0%,
    color-mix(in srgb, var(--background) 75%, transparent) 45%,
    var(--background) 80%
  );
}

.archive-locked-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  padding: 24px;
}

.archive-locked-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-bottom: 6px;
  color: var(--primary);
}

.archive-locked-icon svg {
  width: 22px;
  height: 22px;
  stroke-width: 1.8;
}

.archive-locked-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.35;
  color: var(--text-primary);
}

.archive-locked-subtitle {
  margin: 2px 0 10px;
  max-width: 430px;
  font-size: 13px;
  color: var(--text-primary);
  opacity: 0.58;
  line-height: 1.55;
}

.archive-upgrade-btn {
  min-height: 40px;
  padding: 0 18px;
  border: none;
  border-radius: 10px;
  background: var(--primary);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.15s ease;
}

.archive-upgrade-btn:hover {
  background: var(--primary-hover);
  transform: translateY(-1px);
}

@media (max-width: 480px) {
  .archive-locked-preview {
    min-height: 180px;
  }
}

/* ---------- Empty states ---------- */

.reports-empty-inline {
  text-align: center;
  color: var(--text-primary);
  opacity: 0.5;
  font-size: 13px;
  padding: 24px 0;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ReportsPage.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,4BAA4B;EAC5B,yEAAyE;AAC3E;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA,gDAAgD;;AAEhD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,8EAA8E;AAChF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,yEAAyE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;sEACsE;AACtE;EACE,4BAA4B;EAC5B,8DAA8D;EAC9D,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,6CAA6C;;AAE7C;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,0EAA0E;;AAE1E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iDAAiD;EACjD,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA,kCAAkC;;AAElC;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,iDAAiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;;qCAEqC;;AAErC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,uCAAuC;;AAEvC;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,SAAS;AACX","sourcesContent":["/* ============================================================\n   REPORTS & ARCHIVE PAGE\n   ============================================================ */\n\n.reports-subtitle {\n  color: var(--text-primary);\n  opacity: 0.65;\n  font-size: 14px;\n  line-height: 1.6;\n  max-width: 760px;\n  margin: -8px 0 20px;\n}\n\n/* ---------- Filter bar ---------- */\n\n.reports-filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 22px;\n}\n\n.reports-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 0 14px;\n  min-width: 260px;\n  flex: 1 1 260px;\n  max-width: 360px;\n  color: var(--text-primary);\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.reports-search:focus-within {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 12%, transparent);\n}\n\n.reports-search svg {\n  flex-shrink: 0;\n  opacity: 0.45;\n}\n\n.reports-search input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 14px;\n  width: 100%;\n  color: var(--text-primary);\n}\n\n/* ---------- Custom-styled selects ---------- */\n\n.reports-select-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.reports-select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  height: 100%;\n  border: 1px solid var(--border);\n  background: var(--card-bg);\n  color: var(--text-primary);\n  font-size: 13px;\n  font-weight: 500;\n  padding: 0 30px 0 14px;\n  border-radius: 10px;\n  cursor: pointer;\n  min-width: 130px;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.reports-select:hover {\n  border-color: var(--primary);\n}\n\n.reports-select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 12%, transparent);\n}\n\n.reports-select-caret {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-primary);\n  opacity: 0.45;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n/* When a filter is actively selected (not the \"all\" default), give it\n   a filled, colored look so active filters are obvious at a glance. */\n.reports-select-wrapper.has-value .reports-select {\n  border-color: var(--primary);\n  background: color-mix(in srgb, var(--primary) 6%, transparent);\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.reports-select-wrapper.has-value .reports-select-caret {\n  color: var(--primary);\n  opacity: 0.8;\n}\n\n.reports-clear-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  border: none;\n  background: transparent;\n  color: var(--text-primary);\n  opacity: 0.55;\n  font-size: 13px;\n  cursor: pointer;\n  margin-left: auto;\n  padding: 0 4px;\n  transition: opacity 0.2s ease;\n}\n\n.reports-clear-btn:hover {\n  opacity: 0.9;\n}\n\n/* ---------- Current week panel ---------- */\n\n.current-week-panel {\n  background: rgba(46, 125, 50, 0.06);\n  border: 1px solid rgba(46, 125, 50, 0.18);\n  border-radius: 16px;\n  padding: 20px;\n  margin-bottom: 28px;\n}\n\n.current-week-header {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n\n.current-week-eyebrow {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: #2e7d32;\n  margin-bottom: 6px;\n}\n\n.current-week-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.current-week-title-row h3 {\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0;\n  color: var(--text-primary);\n}\n\n.new-badge {\n  background: #2e7d32;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  padding: 3px 9px;\n  border-radius: 999px;\n}\n\n.download-all-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  color: var(--text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  padding: 9px 16px;\n  border-radius: 10px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s ease;\n}\n\n.download-all-btn:hover {\n  background: var(--hover);\n}\n\n/* ---------- Report cards (shared by current week + archive) ---------- */\n\n.reports-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n  gap: 16px;\n}\n\n.report-card {\n  display: flex;\n  flex-direction: column;\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 18px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.report-card:hover {\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  transform: translateY(-2px);\n}\n\n.report-card-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 14px;\n  flex-shrink: 0;\n}\n\n.report-card-title {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0 0 8px;\n  color: var(--text-primary);\n  line-height: 1.3;\n}\n\n.report-card-summary {\n  font-size: 13px;\n  color: var(--text-primary);\n  opacity: 0.62;\n  line-height: 1.55;\n  margin: 0 0 14px;\n  flex: 1;\n}\n\n.report-card-filesize {\n  font-size: 12px;\n  color: var(--text-primary);\n  opacity: 0.45;\n  margin-bottom: 14px;\n}\n\n.report-card-download {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: 1.5px solid var(--accent, var(--primary));\n  background: transparent;\n  color: var(--accent, var(--primary));\n  font-size: 13px;\n  font-weight: 600;\n  padding: 9px 0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.report-card-download:hover {\n  background: var(--accent, var(--primary));\n  color: #fff;\n}\n\n/* ---------- Archive ---------- */\n\n.archive-section {\n  padding-bottom: 24px;\n}\n\n.archive-eyebrow {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: var(--text-primary);\n  opacity: 0.5;\n  margin-bottom: 12px;\n}\n\n.week-accordion-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.week-accordion-item {\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.week-accordion-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 18px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n}\n\n.week-accordion-header:hover {\n  background: var(--hover);\n}\n\n.week-accordion-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.week-accordion-meta {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-shrink: 0;\n}\n\n.week-accordion-count {\n  font-size: 13px;\n  color: var(--text-primary);\n  opacity: 0.5;\n}\n\n.week-accordion-chevron {\n  transition: transform 0.2s ease;\n  color: var(--text-primary);\n  opacity: 0.5;\n}\n\n.week-accordion-chevron.open {\n  transform: rotate(180deg);\n}\n\n.week-accordion-body {\n  padding: 4px 18px 20px;\n  border-top: 1px solid var(--border);\n  padding-top: 18px;\n}\n\n/* ---------- Loading / error states ---------- */\n\n.reports-status {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 50px 0;\n  color: var(--text-primary);\n  opacity: 0.6;\n  font-size: 14px;\n}\n\n.reports-status-spin {\n  animation: reports-spin 0.8s linear infinite;\n}\n\n@keyframes reports-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.reports-retry-btn {\n  width: fit-content;\n}\n\n/* ---------- Locked archive (demo accounts) ---------- */\n/* A faded, inert preview of the first few archive weeks sits underneath;\n   a bottom-weighted gradient fades it into the page background; the lock\n   card is centered on top of both. */\n\n.archive-locked-preview {\n  position: relative;\n  min-height: 220px;\n  overflow: hidden;\n  border-radius: 14px;\n}\n\n.archive-locked-list {\n  pointer-events: none;\n  user-select: none;\n}\n\n.archive-locked-fade {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to bottom,\n    color-mix(in srgb, var(--background) 15%, transparent) 0%,\n    color-mix(in srgb, var(--background) 75%, transparent) 45%,\n    var(--background) 80%\n  );\n}\n\n.archive-locked-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 6px;\n  padding: 24px;\n}\n\n.archive-locked-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  margin-bottom: 6px;\n  color: var(--primary);\n}\n\n.archive-locked-icon svg {\n  width: 22px;\n  height: 22px;\n  stroke-width: 1.8;\n}\n\n.archive-locked-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.35;\n  color: var(--text-primary);\n}\n\n.archive-locked-subtitle {\n  margin: 2px 0 10px;\n  max-width: 430px;\n  font-size: 13px;\n  color: var(--text-primary);\n  opacity: 0.58;\n  line-height: 1.55;\n}\n\n.archive-upgrade-btn {\n  min-height: 40px;\n  padding: 0 18px;\n  border: none;\n  border-radius: 10px;\n  background: var(--primary);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.15s ease;\n}\n\n.archive-upgrade-btn:hover {\n  background: var(--primary-hover);\n  transform: translateY(-1px);\n}\n\n@media (max-width: 480px) {\n  .archive-locked-preview {\n    min-height: 180px;\n  }\n}\n\n/* ---------- Empty states ---------- */\n\n.reports-empty-inline {\n  text-align: center;\n  color: var(--text-primary);\n  opacity: 0.5;\n  font-size: 13px;\n  padding: 24px 0;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
